import {createContext} from 'react';
import {IProps,ISinistroContext} from '../../interfaces/storage/contexts/ISinistroContext';
export const SinistroContextDefault : ISinistroContext = {
}
export const SinistroContext = createContext<IProps>({sinistroContext:SinistroContextDefault, setSinistroContext:()=>{}});